<script>
	//Components
	import TextInput from '@/Components/TextInput.svelte';
	import { Countries } from '@/Constants/Country';

	export let label = '';
	export let name;
	export let country = '';
	export let value = '';
	export let className = '';
	export let errors = [];

	$: callingCode = country && getCallingCode(country);

	const getCallingCode = (country) => {
		if (country === Countries.AU) {
			return '+61';
		} else if (country === Countries.NZ) {
			return '+64';
		}
	};
	// eslint-disable-next-line no-unused-vars
	$: props = (({ label, name, value, className, errors, ...rest }) => rest)($$props);
</script>

<div class={className}>
	{#if label}
		<label class="form-label" for={name}>{label}</label>
	{/if}
	<div class="flex flex-row">
		{#if country}
			<input
				id={name + '_ext'}
				name={name + '_ext'}
				bind:value={callingCode}
				disabled
				class="w-10 form-input border-none bg-transparent focus:outline-none"
			/>
		{/if}
		<TextInput
			bind:value
			className="w-full"
			bind:name
			bind:errors
			required
			placeholder="Enter numbers only"
			type="text"
			maxlength="10"
		/>
	</div>
</div>
